import { createAsyncThunk } from '@reduxjs/toolkit';

const updateTeamSearchSetting = createAsyncThunk(
  'user/updateTeamSearchSetting',
  async ({ name, value }, {
    rejectWithValue,
    extra: {
      sdk, Logger, utils, showErrorDialog,
    },
  }) => {
    try {
      await sdk.team.setTeamSearchSettings(name, value);
      return { name, value };
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not be set team search setting';
      showErrorDialog(errorMessage);
      Logger.error(new Error(`Can not set team search setting - ${name}`), { error }, [
        'UpdateTeamSearchSettingFailed',
        {
          errorMessage: (error && error.message) || 'NoMessage',
        },
      ]);
      return rejectWithValue(error);
    }
  },
);

export default updateTeamSearchSetting;
